<template>
  <section class="ya-te-bg-gray">
    <div class="co-container-md mx-auto px-4 pb-8 pt-20">
      <h2 class="ya-te-page-title ya-te-text-primary mb-6 text-center font-extrabold leading-normal sm:mb-12">
        相談した方の声
      </h2>

      <!-- カルーセル -->
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="1"
        :space-between="12"
        :breakpoints="{
          '576': {
            slidesPerView: 2,
          },
          '992': {
            slidesPerView: 3,
          },
        }"
        :pagination="{
          clickable: true,
        }"
      >
        <SwiperSlide
          :key="1"
          class="!h-auto"
        >
          <div class="h-full">
            <img
              src="~/assets/images/YaTe/YaTeCounseling/Voice/counseling-voice-1.svg"
              alt="美容師を退職しエンジニアへ"
              width="316"
              height="326"
              loading="lazy"
              class="mx-auto"
            >
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="2"
          class="!h-auto"
        >
          <div class="h-full">
            <img
              src="~/assets/images/YaTe/YaTeCounseling/Voice/counseling-voice-2.svg"
              alt="目指すキャリアへのスタート地点に"
              width="316"
              height="326"
              loading="lazy"
              class="mx-auto"
            >
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="3"
          class="!h-auto"
        >
          <div class="h-full">
            <img
              src="~/assets/images/YaTe/YaTeCounseling/Voice/counseling-voice-3.svg"
              alt="環境変化を好機と捉え転職へ"
              width="316"
              height="326"
              loading="lazy"
              class="mx-auto"
            >
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');
</style>
